import { type VariantProps, cva } from 'class-variance-authority';
import clsx from 'clsx';

const COLORS = [
  'bg-fx-brand-600',
  'bg-fx-green',
  'bg-fx-blue',
  'bg-fx-purple',
  'bg-fx-rose',
  'bg-fx-teal',
  'bg-fx-amber',
  'bg-fx-neutral-600',
] as const;

/** Maps a string to a consistent color so the same name always gets the same avatar color. */
function getDeterministicColor(value: string): string {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) % 1_000_000_007;
  }
  return COLORS[hash % COLORS.length];
}

const letterAvatarVariants = cva(
  'flex shrink-0 items-center justify-center rounded-full font-medium text-white',
  {
    variants: {
      size: {
        xs: 'h-4 w-4 text-[0.5rem]',
        sm: 'h-5 w-5 text-[0.625rem]',
        md: 'h-6 w-6 text-xs',
        lg: 'h-8 w-8 text-sm',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
);

type LetterAvatarProps = VariantProps<typeof letterAvatarVariants> & {
  name: string;
  className?: string;
};

export function LetterAvatar({ name, size, className }: LetterAvatarProps) {
  return (
    <div
      className={clsx(
        letterAvatarVariants({ size }),
        getDeterministicColor(name),
        className,
      )}
    >
      {name.charAt(0).toUpperCase()}
    </div>
  );
}
